import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you submit an enquiry or viewing request we collect your name, email address and, if you provide them, your phone number, area of interest and message.",
  },
  {
    title: "How we use it",
    body: "Your details are used only to respond to your enquiry about The 126 House and to arrange viewings. They are shared with the listing agent, Sarah Dyer of Bayleys, and with NF Construction. We do not sell your information or add you to marketing lists.",
  },
  {
    title: "Storage",
    body: "Enquiries are stored securely by our website provider and retained only as long as needed to manage the sale of the property.",
  },
  {
    title: "Your rights",
    body: "Under the New Zealand Privacy Act 2020 you may ask to see or correct the personal information we hold about you, or ask us to delete it. Contact info@nfconstruction.co.nz.",
  },
];

export default function Privacy() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="min-h-screen bg-[#1a1e1a]">
      <Header />
      <main className="max-w-3xl mx-auto px-6 md:px-12 pt-36 pb-24" data-testid="privacy-page">
        <p className="text-[#d6cdb4] text-sm tracking-[0.25em] uppercase mb-6">Privacy notice</p>
        <h1 className="text-4xl md:text-5xl text-white font-light mb-12">How we handle your details</h1>
        <div className="space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="text-white text-lg mb-3">{s.title}</h2>
              <p className="text-white/80 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
